module.exports = __webpack_public_path__ + "static/media/360 report.791cd33a.svg";